import { Theme, ThemeConfig, ThemeDesignConfig } from '../contracts';

import { images } from './config-images';
import { paymentImages } from './config-pm-images';

export const themeConfig: ThemeConfig = {
  defaultTitle: 'Bitstore',
  name: 'Bitstore',

  // images2
  errorIcon: images.errorIcon.path,
  successIcon: images.successIcon.path,
  infoIcon: images.infoIcon.path,
  crossArrowsIcon: `url(${images.crossArrowsIcon.path}) no-repeat 50% / contain`,

  // fonts
  fontFamily: 'Roboto',
  fontFamilyCyrillic: '',
  mainFont: 'Roboto, sans-serif',

  // media
  smallMobileSize: '374px',
  mobileSize: '767px',
  tabletSize: '1024px',

  // jivo site
  jivoMobile: `url(${images.jivoMobile.path})`,

  // circle progress bar
  progressCircleDesktopSize: 170,
  progressCircleMobileSize: 140,
  progressCircleTrailColor: '#FFFFFF',

  images,
  paymentImages,
};

export const themeDesignConfig: ThemeDesignConfig = {
  colors: {
    button: {
      fill: {
        primaryBg: '#FFD04E',
        primaryHover: '#FFEAB2',
        primaryPressed: '#FFC428',
        disabled: '#64748B',
        secondaryBg: '#FFD04E20',
        secondaryHover: '#FFD04E20',
        secondaryPressed: '#FFD04E40',
        dangerBg: '#F87171',
        dangerHover: '#FCA5A5',
        dangerPressed: '#EF4444',
        tertiary01: '#000000',
        tertiaryHover01: '#FFD04E20',
        tertiaryPressed01: '#FFD04E40',
        tertiary02: '#000000',
        tertiaryHover02: '#60A5FA20',
        tertiaryPressed02: '#60A5FA40',
        tertiary03: '#000000',
        tertiaryHover03: '#F8717120',
        tertiaryPressed03: '#F8717140',
        gradient: 'linear-gradient(180deg, #ffd04e 0%, #d8a61b 100%)',
      },
      text: {
        primaryLabel: '#0F172A',
        secondaryLabel: '#FACC15',
        tertiaryLabel01: '#FACC15',
        tertiaryLabel02: '#60A5FA',
        tertiaryLabel03: '#F87171',
        linkLabel: '#CBD5E1',
        linkLabelHover: '#F1F5F9',
        linkLabelPressed: '#94A3B8',
        textButtonDisable: '#475569',
      },
      border: {
        secondary: '#FACC15',
        border01: '#FACC15',
        border02: '#60A5FA',
        border03: '#F87171',
        borderDisable: '#475569',
      },
      icon: {
        icon01: '#FACC15',
        iconHover01: '#FEF08A',
        iconPressed01: '#EAB308',
        icon02: '#CBD5E1',
        iconHover02: '#E2E8F0',
        iconPressed02: '#64748B',
        iconDisable: '#475569',
      },
    },
    background: {
      mainPage: '#1F2026',
      overlay: '#1B1C2180',
      foreground: '#2D3344',
      loader: 'rgba(0, 0, 0, 0.4)',
      modal: '#2D3344',
      header: '#2D3344',
      brand: '#FACC15',
      success: '#22C55E',
      warning: '#EAB308',
      danger: '#EF4444',
      info: '#3B82F6',
      inverse: '#F8FAFC',
    },
    layer: {
      layer01: '#2D3344',
      layerHover01: '#4E5773',
      layerSelected01: '#1E293B',
      layerBrand: 'rgba(250, 204, 21, 0.2)',
      layer02: '#2D3344',
      layer03: '#334155',
      layer04: '#323E52',
      success: 'rgba(74, 222, 128, 0.2)',
      warning: 'rgba(250, 204, 21, 0.2)',
      danger: 'rgba(239, 68, 68, 0.1)',
      info: 'rgba(59, 130, 246, 0.1)',
    },
    text: {
      primary: '#F8FAFC',
      secondary: '#CBD5E1',
      subtle: '#94A3B8',
      placeholder: '#64748B',
      inverse: '#0F172A',
      disabledSubtle: '#475569',
      disabledStrong: 'rgba(255, 255, 255, 0.5)',
      brand: '#FACC15',
      success: '#22C55E',
      warning: '#F59E0B',
      danger: '#F87171',
      info: '#60A5FA',
    },
    icons: {
      primary: '#F8FAFC',
      secondary: '#CBD5E1',
      subtle: '#94A3B8',
      disabledStrong: 'rgba(255, 255, 255, 0.5)',
      inverse: '#0F172A',
      success: '#22C55E',
      warning: '#F59E0B',
      danger: '#F87171',
      info: '#3B82F6',
    },
    border: {
      system: '#575C69',
      tile: '#475569',
      separator: '#575C69',
      field: 'rgba(0, 0, 0, 0.00)',
      interactive: '#94A3B8',
      hover: '#E2E8F0',
      focus: '#FACC15',
      success: '#22C55E',
      warning: '#F59E0B',
      danger: '#EF4444',
      info: '#3B82F6',
    },
    field: {
      default: '#1E2330',
      hover: '#272E41',
      focused: '#181D29',
      disabled: '#3A4153',
    },
    bonuses: {
      bronze01: '#F59E0B',
      bronze02: 'rgba(245, 158, 11, 0.2)',
      silver01: '#94A3B8',
      silver02: 'rgba(148, 163, 184, 0.2)',
      gold01: '#EAB308',
      gold02: 'rgba(234, 179, 8, 0.2)',
      platinum01: '#93C5FD',
      platinum02: 'rgba(147, 197, 253, 0.2)',
      diamond01: '#67E8F9',
      diamond02: 'rgba(103, 232, 249, 0.2)',
    },
    overlay: {
      '01': 'rgba(255,255,255,0.1)',
      '02': 'rgba(255,255,255,0.2)',
      '03': 'rgba(255,255,255,0.3)',
      '04': 'rgba(255,255,255,0.4)',
      '05': 'rgba(255,255,255,0.5)',
      '06': 'rgba(255,255,255,0.6)',
      '07': 'rgba(255,255,255,0.7)',
      '08': 'rgba(255,255,255,0.8)',
      '09': 'rgba(255,255,255,0.9)',
    },
  },

  spacing: {
    's-none': '0px',
    's-01': '1px',
    's-02': '2px',
    's-04': '4px',
    's-06': '6px',
    's-08': '8px',
    's-10': '10px',
    's-12': '12px',
    's-16': '16px',
    's-20': '20px',
    's-24': '24px',
    's-28': '28px',
    's-32': '32px',
    's-36': '36px',
    's-40': '40px',
    's-44': '44px',
    's-48': '48px',
    's-56': '56px',
    's-64': '64px',
    's-80': '80px',
    'btn-content': '8px',
    'btn-y': '12px',
    'btn-x': '24px',
    'form-y': '40px',
    'form-x': '28px',
    'frame-y': '36px',
    'frame-x': '36px',
    'modal-y': '44px',
    'modal-x': '36px',
  },

  radius: {
    mainStrong: '24px',
    mainSubtle: '8px',
    frame: '24px',
    modal: '24px',
    button: '4px',
    field: '8px',
    layer: '4px',
    card: '12px',
  },

  typography: {
    fontFamily: 'Roboto',
    fontFamilyCyrillic: '',
    mainFont: 'Roboto, sans-serif',
    'display-large': {
      size: '40px',
      height: '48px',
      weight: 500,
      family: `Roboto, sans-serif`,
    },
    'display-medium': {
      size: '32px',
      height: '38px',
      weight: 500,
      family: `Roboto, sans-serif`,
    },
    'heading-large': {
      size: '28px',
      height: '32px',
      weight: 500,
      family: `Roboto, sans-serif`,
    },
    'heading-medium': {
      size: '22px',
      height: '26px',
      weight: 500,
      family: `Roboto, sans-serif`,
    },
    'heading-small': {
      size: '18px',
      height: '22px',
      weight: 600,
      family: `Roboto, sans-serif`,
    },
    'label-large': {
      size: '16px',
      height: '20px',
      weight: 500,
      family: `Roboto, sans-serif`,
    },
    'label-medium': {
      size: '14px',
      height: '20px',
      weight: 600,
      family: `Roboto, sans-serif`,
    },
    'label-small': {
      size: '12px',
      height: '14px',
      weight: 500,
      family: `Roboto, sans-serif`,
    },
    'paragraph-large': {
      size: '16px',
      height: '22px',
      weight: 400,
      family: `Roboto, sans-serif`,
    },
    'paragraph-medium': {
      size: '14px',
      height: '20px',
      weight: 400,
      family: `Roboto, sans-serif`,
    },
    'paragraph-small': {
      size: '12px',
      height: '14px',
      weight: 400,
      family: `Roboto, sans-serif`,
    },
    'overline-medium': {
      size: '12px',
      height: '16px',
      weight: 400,
      family: `Roboto, sans-serif`,
    },
    'overline-small': {
      size: '11px',
      height: '14px',
      weight: 400,
      family: `Roboto, sans-serif`,
    },
    'overline-x-small': {
      size: '10px',
      height: '14px',
      weight: 400,
      family: `Roboto, sans-serif`,
    },
  },

  illustrations: {
    referral: images.referralIllustration,
    phoneProfile: images.phoneProfileIllustration,
    api: images.apiIllustration,
    emptyTable: images.emptyTableIllustration,
  },

  background: {
    main: `url(${images.mainBg.path}) no-repeat 50% / cover`,
    mobile: `url(${images.mainBgMobile.path}) repeat top / cover 100%, #16161B`,
  },
};

export default { ...themeConfig, ...themeDesignConfig } as Theme;
